import Dialog from 'components/common/Dialog';
import { AnimatePresence, domMax, LazyMotion } from 'framer-motion';
import { createPortal } from 'react-dom';
import useDialogStore from 'stores/dialogStore';

// 어느 화면에서 불려도 맨 위에 떠야 해서 body 에 붙인다(시트는 기본이 #hMainContainer).
const DialogRouter = () => {
  const dialogs = useDialogStore((state) => state.dialogs);

  return createPortal(
    <LazyMotion features={domMax} strict>
      <AnimatePresence>
        {dialogs.map((dialog) => (
          <Dialog key={dialog.id} dialog={dialog} />
        ))}
      </AnimatePresence>
    </LazyMotion>,
    document.body,
  );
};

export default DialogRouter;
